exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfieldset {\n    display: block;\n    margin-left: 2px;\n    margin-right: 2px;\n    padding-top: 0.35em;\n    padding-bottom: 0.625em;\n    padding-left: 0.75em;\n    padding-right: 0.75em;\n    border: 2px groove;\n}\nlegend {\n    width: auto !important;\n    padding: 5px !important;\n}\n.form-label label {\n    color: #484747 !important;\n}\n.labels {\n    font-weight: bold;\n}\n.notes {\n    color: #7b8288 !important;\n}\n", ""]);

// exports
